export const GET_AMBASSADORS_FOR_ROOT_PATH = '/graphql/execute.json/yme/getAmbassadorsForRoot;path=';
export const GET_AMBASSADOR_BY_PATH = '/graphql/execute.json/yme/getAmbassadorByPath;path=';
